import React from "react";

//Custom Comp
import ThemeTab from "./ThemeTab";

//Data Files
import BusinessThemes from "../../Data/ThemeStoreData/WixThemes/BusinessThemes";

function ThemeTabsContainer() {
  return (
    <div style={{ width: "100%", overflow: "hidden", margin: "auto" }}>
      <ThemeTab data={BusinessThemes} onlyPics={false} />
    </div>
  );
}

export default ThemeTabsContainer;
